export default __webpack_public_path__ + "static/sql-96af83e68e3b32fb2dd7dd8955ba2945.png";